module.exports = __webpack_public_path__ + "img/winter_greevil_chewy.062706cc.png";